export default "__VITE_ASSET__DxmtOFUS__"